import { useMutation } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';
import { useChooseFiles } from '@gogame/hooks-ts';

import { replaceInvoiceAttachment } from 'scenes/FinancialResults/sources/invoices';
import { uploadFile } from 'scenes/FinancialResults/sources/financialResults';

import { replaceInvoiceAttachment as key } from '../queryKeyFactory';

export const useReplaceInvoice = () => {
  const { showSuccessMessage, showErrorMessage } = useScreenMessage();

  const chooseFiles = useChooseFiles({
    multiple: false,
    accept:
      'application/pdf,image/png,image/jpeg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const mutation = useMutation(key(), async ({ file, invoiceId }) => {
    const { id: fileId } = await uploadFile(file);
    return await replaceInvoiceAttachment({
      id: invoiceId,
      fileId,
    });
  });

  const handleAction = async ({ id: invoiceId }) => {
    try {
      const file = await chooseFiles();
      const response = await mutation.mutateAsync({ invoiceId, file });
      showSuccessMessage('Invoices was uploaded.');
      return response;
    } catch (e) {
      showErrorMessage(e.message);
      return Promise.reject(e);
    }
  };
  return [handleAction, mutation];
};
